'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactSelect = require('react-select');var _reactSelect2 = _interopRequireDefault(_reactSelect);
var _PaginationStaff = require('./PaginationStaff.scss');var styles = _interopRequireWildcard(_PaginationStaff);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

PaginationStaff = function (_Component) {_inherits(PaginationStaff, _Component);function PaginationStaff() {_classCallCheck(this, PaginationStaff);return _possibleConstructorReturn(this, _Component.apply(this, arguments));}PaginationStaff.prototype.
  renderDesktop = function renderDesktop() {var _props =










    this.props,selected = _props.selected,current = _props.current,total = _props.total,rowsPerPage = _props.rowsPerPage,onForward = _props.onForward,onBack = _props.onBack,onGoTo = _props.onGoTo,onRowsChange = _props.onRowsChange,translate = _props.translate;

    var nextStart = current + rowsPerPage.value - 1;
    var last = nextStart < total ? nextStart : total;
    var options = [
    { value: 10, label: 10 },
    { value: 50, label: 50 },
    { value: 100, label: 100 }];


    return (
      _react2.default.createElement('div', { className: styles.paginationBlock },
        _react2.default.createElement('div', { className: styles.navigateBtn },
          _react2.default.createElement('button', { onClick: onForward, className: styles.forwardBtn }, _react2.default.createElement('span', {
              className: 'icon-back' })),

          _react2.default.createElement('button', { onClick: onBack, className: styles.backBtn }, _react2.default.createElement('span', {
              className: 'icon-back' }))),


        _react2.default.createElement('span', null, current + '-' + last + ' ' + translate('managePage', 'of') + ' ' + total),
        _react2.default.createElement('div', { className: styles.inputSection },
          _react2.default.createElement('span', null, translate('managePage', 'goTo')),
          _react2.default.createElement('div', { className: styles.inputWrapper },
            _react2.default.createElement('input', {
              type: 'number',
              value: selected,
              onChange: function onChange(e) {return onGoTo(+e.target.value);} }))),



        _react2.default.createElement('div', { className: styles.inputSection },
          _react2.default.createElement('span', {
              className: styles.showRows },
            translate('managePage', 'showRows')),
          _react2.default.createElement(_reactSelect2.default, {
            value: rowsPerPage,
            options: options,
            onChange: onRowsChange,
            clearable: false,
            searchable: false }))));




  };PaginationStaff.prototype.

  renderMobile = function renderMobile() {var _props2 =







    this.props,current = _props2.current,total = _props2.total,rowsPerPage = _props2.rowsPerPage,onForward = _props2.onForward,onBack = _props2.onBack,translate = _props2.translate;
    var nextStart = current + rowsPerPage.value - 1;
    var last = nextStart < total ? nextStart : total;

    return (
      _react2.default.createElement('div', { className: styles.paginationBlock },
        _react2.default.createElement('button', { onClick: onForward, className: styles.forwardBtn }, _react2.default.createElement('span', {
            className: 'icon-back' })),

        _react2.default.createElement('span', null, current + '-' + last + ' ' + translate('managePage', 'of') + ' ' + total),
        _react2.default.createElement('button', { onClick: onBack, className: styles.backBtn }, _react2.default.createElement('span', {
            className: 'icon-back' }))));



  };PaginationStaff.prototype.

  render = function render() {var
    isMobile = this.props.isMobile;
    return isMobile ? this.renderMobile() : this.renderDesktop();
  };return PaginationStaff;}(_react.Component);


PaginationStaff.propTypes = {
  current: _propTypes2.default.number.isRequired,
  total: _propTypes2.default.number.isRequired,
  selected: _propTypes2.default.number.isRequired,
  rowsPerPage: _propTypes2.default.shape({
    value: _propTypes2.default.number.isRequired,
    label: _propTypes2.default.number.isRequired }).
  isRequired,
  onForward: _propTypes2.default.func.isRequired,
  onBack: _propTypes2.default.func.isRequired,
  onGoTo: _propTypes2.default.func.isRequired,
  onRowsChange: _propTypes2.default.func.isRequired,
  isMobile: _propTypes2.default.bool.isRequired,
  translate: _propTypes2.default.func.isRequired };exports.default =


PaginationStaff;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/components/Pagination/PaginationStaff.js
// module id = 3001
// module chunks = 0